import React, { useRef } from 'react';
import { CloseIcon } from 'components';
import { ModelStyle } from './Component.style';
import clsx from 'clsx';
import { DialogContent, DialogTitle } from '@mui/material';

function DynModel({
  openModal,
  modelTitle,
  handleCancelModal,
  content,
  modalchanges,
  removeHeader,
  action,
  ...props
}) {
  const scrollRef = useRef(null);

  return (
    <ModelStyle
      className={clsx(
        'modelContainer',
        removeHeader && 'no-header',
        modalchanges
      )}
      open={openModal}
      onClose={handleCancelModal}
      {...props}
    >
      {!removeHeader && (
        <>
          {modelTitle && <DialogTitle className="dialog-title">{modelTitle}</DialogTitle>}
          <CloseIcon
            customStyle="post-close-icon"
            onClick={handleCancelModal}
          />
        </>
      )}
      <DialogContent
        dividers
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          // padding: 0,
        }}
      >
        <div
          ref={scrollRef}
          style={{
            overflowY: 'auto',
            paddingBottom: `12px`,
            transition: 'padding-bottom 0.3s ease',
            flex: 1,
          }}
        >
          {content}
        </div>
      </DialogContent>
      {action}
    </ModelStyle>
  );
}

export default DynModel;
